module.exports = __webpack_public_path__ + "img/hy5.b20a5d9b.png";